import React, { useState } from 'react';
import Icon from 'react-fontawesome';

const ScrollButton = () => {

    const [visible, setVisible] = useState(false)

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 300) {
            setVisible(true)
        }
        else if (scrolled <= 300) {
            setVisible(false)
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
            /* you can also use 'auto' behaviour
               in place of 'smooth' */
        });
    };

    window.addEventListener('scroll', toggleVisible);

    return (
        <div className='scroll-top-container floating2'>
            <div className='scroll-top-button floating item-center' style={{ display: visible ? 'inline' : 'none' }}  onClick={scrollToTop}>
            <img
                src={require('../assets/image/up.png')}
                style={{ width: '3vh', bottom: '-0.5vh', position: 'relative' }}
            />
            </div>
        </div>
    );
}

export default ScrollButton;